import { useEffect } from "react";
import { useLazyMyInfoQuery, useRegisterMutation } from "app/apiSlice";
import { isAxiosError } from "axios";
import LoadingSpinner from "components/LoadingSpinner";
import { useNavigate } from "react-router-dom";
import AuthService from "services/authService";
import TokenService from "services/tokenService";
import { StorageUtils } from "utils/storageUtils";

const LineCallback = () => {
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(window.location.search);
  const code = searchParams.get("code");
  const state = searchParams.get("state");
  const savedState = sessionStorage.getItem("oauth_state");
  const isModal = StorageUtils.IsLoginModal.get();
  const [fetchMyInfo] = useLazyMyInfoQuery();
  const [register] = useRegisterMutation();

  useEffect(() => {
    if (!code || !state) {
      navigate("/login");
      return;
    }
    if (savedState && state !== savedState) {
      alert("잘못된 인증 요청입니다.");
      navigate("/login");
      return;
    }
    sessionStorage.removeItem("oauth_state");

    const getToken = async () => {
      try {
        const response = await AuthService.lineLogin(code, state);
        if (response.status < 300) {
          TokenService.setAccessToken(response.data.accessToken);
          StorageUtils.RecentLoginMethod.set("LINE");
          const myInfo = await fetchMyInfo().unwrap();

          if (myInfo.userStatus === "ACTIVE") {
            navigate(isModal ? "/search-results" : "/");
            return;
          }
          if (myInfo.userStatus === "PENDING") {
            navigate("/auth/additional-info", {
              state: {
                userInfo: {
                  firstName: myInfo.name || "",
                  phoneNumber: myInfo.phone || "",
                  email: myInfo.email || "",
                  providerId: myInfo.provider || "",
                },
                ssoName: "LINE",
              },
            });
            return;
          }
          navigate("/login");
        }
      } catch (error) {
        if (isAxiosError(error)) {
          const userInfo = error.response?.data?.userInfo ?? {};

          if (!userInfo.providerId) {
            navigate("/auth/additional-info", {
              state: { userInfo, ssoName: "LINE" },
            });
            return;
          }

          const form = new FormData();
          form.append("name", userInfo.firstName ?? "");
          form.append("email", userInfo.email ?? "");
          form.append("phone", userInfo.phoneNumber ?? "");
          form.append("ssoId", userInfo.providerId);
          form.append("ssoName", "LINE");

          try {
            const signup = await register(form).unwrap();
            TokenService.setAccessToken(signup.accessToken);
            StorageUtils.RecentLoginMethod.set("LINE");
            navigate("/auth/additional-info", {
              state: { userInfo, ssoName: "LINE" },
            });
            return;
          } catch {
            alert("LINE Social signup failed");
            navigate("/login");
            return;
          }
        }
        alert("LINE Social Login failed");
        navigate("/login");
        return;
      }
    };
    getToken();
  }, [code, state, savedState, fetchMyInfo, register, isModal, navigate]);

  return <LoadingSpinner />;
};

export default LineCallback;
